module.exports = __webpack_public_path__ + "static/media/miles-calendar.8daac97a.svg";